import FreeFormConverter from "./free_form/converter";
import GridConverter from "./grid/converter";

/**
 * Resolves the layout type from shell state.
 *
 * Accepts:
 *   - the playground shell state itself (has definitionObjectBackup + definition)
 *   - the DDB metadata record carried in shell.definition (post-create-response only)
 *   - the wire-format shell object: { object: { layout, ... } }
 *   - the bare definition JSON: { layout, components, ... }
 *
 * Order of resolution:
 *   1. shell.definitionObjectBackup.layout.type (canonical — comes from S3 JSON)
 *   2. shell.definition.layout.type (only set on freshly created playgrounds)
 *   3. shape.object.layout.type (alternate wire envelope)
 *   4. shape.layout.type (bare definition JSON)
 *   5. "free_form" (legacy default)
 *
 * Returns "free_form" or "grid".
 */
export function resolveLayoutType(shape) {
  return shape?.definitionObjectBackup?.layout?.type
    ?? shape?.definition?.layout?.type
    ?? shape?.object?.layout?.type
    ?? shape?.layout?.type
    ?? "free_form";
}

/**
 * Returns the appropriate converter instance for the given shell state or definition.
 */
export function pickConverter(shape, shellInterface) {
  if (resolveLayoutType(shape) === "grid") {
    return new GridConverter(shellInterface);
  }
  return new FreeFormConverter(shellInterface);
}

// Named re-export for call sites that only need static helpers (same on both layouts).
export { default as Converter } from "./free_form/converter";
